<template>
  <div class="goods-spec-image-main">
    <el-divider></el-divider>
    <div class="d-flex align-items-center">
      <span style="font-size: 14px; color: #606266;line-height: 35px;">
        {{ title || '--' }}
      </span>
    </div>
    <el-divider></el-divider>
    <GoodsImageList :data="data" />
  </div>
</template>
<script>
import GoodsImageList from '../../../goods-image-list'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    title: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  components: { GoodsImageList },
}
</script>

<style lang="scss" scoped>
.el-divider.el-divider--horizontal {
  margin: 5px 0;
}
::v-deep .el-card__body {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
